export default {
  header: {
    title: 'Codice promo o Gift card',
  },
  available_codes: {
    title_one: 'Codice disponibile ({{count}})',
    title_other: 'Codici disponibili ({{count}})',
    min_threshold: 'Min {{value}}',
    percentage_off: '{{discount}}% di sconto su questo ordine',
    amount_off: '{{amount}} di sconto su questo ordine',
  },
  content: {
    input: {
      placeholder: 'Inserisci un codice',
    },
    buttons: {
      done: 'Fatto',
      apply: 'Applica',
      applied: 'Applicato ✓',
    },
  },
};
